const initialState = {
    currentLanguage: {
        code: 'en',
        rtl: false
    },
    languages: [],
    translations: {},
};

export default function (state = initialState, {payload, type} = action) {

    switch (type) {

        default:
            return state;
    }
}
